import { Box, Icon, IconProps, Link } from '@cloudscape-design/components';
import { useTranslate } from 'src/i18n/useTranslate';
import InfoPageTemplate from 'src/templates/info-page-template/info-page-template';
import { useNavigate } from 'react-router-dom';
import { CONTACT_LINK } from 'src/utils/constants';

import './not-found-page.scss';
import { useEffect } from 'react';
import initialMetricsPublisher from 'src/metrics';
import { truncateString } from 'src/utils/utils';
import * as KatalMetrics from '@amzn/katal-metrics';

type NotFoundProps = {
    path: string;
};

const NotFound = ({ path }: NotFoundProps) => {
    const t = useTranslate();
    const navigate = useNavigate();

    useEffect(() => {
        const errorPageMetricsPublisher =
            initialMetricsPublisher.newChildActionPublisherForMethod(
                'NotFoundPageView'
            );

        const notFoundPageData = {
            url: truncateString(path ?? ''),
            referrer: truncateString(document.referrer),
            timestamp: new Date().toISOString(),
        };

        errorPageMetricsPublisher.publish(
            new KatalMetrics.Metric.String(
                'gru.not.found.page.view',
                JSON.stringify(notFoundPageData)
            )
        );
    }, []);

    const buttonProps = {
        iconName: 'caret-left-filled' as IconProps.Name,
        onClick: () => navigate('/'),
        text: t('not_found_go_home_button', 'Go to homepage'),
    };
    return (
        <InfoPageTemplate
            headerText={t('page_not_found_header', 'Page Not Found')}
            icon={<Icon name="security" size="inherit" variant="error" />}
            buttonProps={buttonProps}
        >
            <div className={'not-found-container'}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        alignItems: 'flex-start',
                    }}
                >
                    <Box variant="p">
                        {t(
                            'not_found_moved_or_deleted',
                            'This page may have been moved or deleted. Please try these options:'
                        )}
                    </Box>
                    <Box variant="p">
                        &nbsp;&nbsp;🔎&nbsp;&nbsp;
                        {t(
                            'not_found_search',
                            'Use the search bar above to find what you need'
                        )}
                    </Box>
                    <Box variant="p">
                        &nbsp;&nbsp;🏠&nbsp;&nbsp;
                        {t(
                            'not_found_explore',
                            'Click on the "Explore" button above to navigate to what you need'
                        )}
                    </Box>
                    <Box variant="p">
                        {t(
                            'not_found_contact',
                            'Need help? Contact our team: '
                        )}
                        <Link href={CONTACT_LINK} target="_blank">
                            <Icon
                                name="external"
                                ariaLabel={t(
                                    'not_found_contact_us',
                                    'contact us'
                                )}
                            />
                        </Link>{' '}
                    </Box>
                </div>
            </div>
        </InfoPageTemplate>
    );
};

export default NotFound;
